import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { ApiService } from '@shared/services/api.service';
import { User } from '@core/models';

@Component({
	selector: 'app-pricing',
	templateUrl: './pricing.component.html',
	styleUrls: ['./pricing.component.scss'],
})
export class PricingComponent implements OnInit {
	vipImage = 'assets/images/vip/vip-ads.svg';
	adView = 'assets/images/vip/ad-view.svg';
	buttonImg = 'assets/images/vip/Vector.png';

	constructor(
		private title: Title,
		private route: ActivatedRoute,
		public locale: LocaleService,
		public viewport: ViewportService,
		private auth: AuthService,
		private api: ApiService,
		private router: Router
	) {}

	embedded: boolean = false;
	queryAdID: string;
	queryTitle: string;
	userID: string;
	tempToken: string;
	user: User = this.auth.user();
	showBasic: boolean = true;
	type: string;
	adType: string;
	showPremiumBtn: boolean = false;
	category: string = '0';
	pay = 1;

	ngOnInit(): void {
		if (!!this.user) {
			this.title.setTitle(this.locale.translations['payment']['n345'] + ' | ' + this.locale.translations['header']['n0']);

			this.route.queryParams.subscribe((queries: Params) => {
				this.embedded = queries['embedded'];
				this.queryAdID = queries['adID'];
				this.queryTitle = queries['title'];
				this.type = queries['type'];
				this.tempToken = queries['tempToken'];
				this.adType = queries['adType'];

				if (queries['Cat']) {
					this.category = queries['Cat'];
				}

				if (this.tempToken) {
					var replacetempToken = this.tempToken.split(' ').join('+');
				}

				if (queries['adID']) {
					this.showBasic = false;
				}

				if (queries['embedded'] && queries['tempToken']) {
					const body: FormData = new FormData();
					body.append('lang', this.locale.lang);
					body.append('token', replacetempToken);
					this.api.verifyTempToken(body).subscribe((res) => {
						if (res.status === '1') {
							this.auth.login(
								res['response']['userID'],
								res['response']['name'],
								res['response']['phone'],
								res['response']['verified'],
								res['response']['token'],
								res['response']['userType']
							);

							this.userID = res['response']['userID'];
						}
					});
				} else if (this.user && queries['embedded'] && !queries['tempToken']) {
					this.auth.logout();
				}
			});
		} else {
			this.router.navigate(['login']);
		}
	}

	getPrice() {
		if (this.category === '15' || this.category === '17' || this.category === '0') {
			this.pay = 1;
		} else {
			this.pay = 0;
		}

		return this.pay;
	}
}
